// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DriveTimeScatterPlot .scatter-plot-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
.DriveTimeScatterPlot .scatter-plot-card .card-body {
  padding: 0;
}
.DriveTimeScatterPlot .scatter-plot-header {
  padding: 16px 2rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.DriveTimeScatterPlot .scatter-plot-header:hover {
  background-color: #f8f9fa;
}
.DriveTimeScatterPlot .scatter-plot-header .header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.DriveTimeScatterPlot .scatter-plot-header .header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.DriveTimeScatterPlot .scatter-plot-header .header-left .chart-icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.DriveTimeScatterPlot .scatter-plot-header .header-left .chart-icon i {
  font-size: 16px;
  color: #333;
}
.DriveTimeScatterPlot .scatter-plot-header .header-left .header-text .header-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 2px 0;
}
.DriveTimeScatterPlot .scatter-plot-header .header-left .header-text .header-subtitle {
  font-size: 14px;
  color: #666;
  margin: 0;
}
.DriveTimeScatterPlot .scatter-plot-header .collapse-icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.DriveTimeScatterPlot .scatter-plot-header .collapse-icon i {
  font-size: 14px;
  color: #666;
  transition: transform 0.2s ease;
}
.DriveTimeScatterPlot .scatter-plot-content {
  border-top: 1px solid #e0e0e0;
  padding: 2rem;
}
.DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-header {
  margin-bottom: 2rem;
}
.DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-header .chart-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}
.DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-header .chart-header-left .chart-icon-small {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-header .chart-header-left .chart-icon-small i {
  font-size: 14px;
  color: #333;
}
.DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-header .chart-header-left .chart-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
}
.DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-header .chart-header-left .info-icon {
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-header .chart-header-left .info-icon i {
  font-size: 1rem;
  color: #6c757d;
}
.DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 350px;
  background: #f8f9fa;
  border-radius: 8px;
  padding: 40px 20px;
  text-align: center;
}
.DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-placeholder .chart-icon-large {
  margin-bottom: 20px;
}
.DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-placeholder .chart-icon-large i {
  font-size: 48px;
  color: #6c757d;
  background: #e9ecef;
  padding: 2rem;
  border-radius: 8px;
  width: 96px;
  height: 96px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-placeholder .placeholder-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 1rem;
  max-width: 400px;
}
.DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-placeholder .placeholder-description {
  font-size: 14px;
  color: #666;
  margin-bottom: 32px;
  line-height: 1.5;
  max-width: 400px;
}
.DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-placeholder .requirements-section {
  text-align: left;
  max-width: 350px;
}
.DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-placeholder .requirements-section .requirements-header {
  font-size: 1rem;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 16px;
  text-align: center;
}
.DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-placeholder .requirements-section .requirements-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-placeholder .requirements-section .requirements-list .requirement-item {
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  color: #333;
  margin-bottom: 1rem;
  gap: 8px;
}
.DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-placeholder .requirements-section .requirements-list .requirement-item:last-child {
  margin-bottom: 0;
}
.DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-placeholder .requirements-section .requirements-list .requirement-item .requirement-bullet {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-top: 6px;
  flex-shrink: 0;
}
.DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-placeholder .requirements-section .requirements-list .requirement-item .requirement-bullet.red {
  background-color: #dc3545;
}
.DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-placeholder .requirements-section .requirements-list .requirement-item .requirement-bullet.green {
  background-color: #28a745;
}
.DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-placeholder .requirements-section .requirements-list .requirement-item .requirement-bullet.blue {
  background-color: #007bff;
}
@media (max-width: 768px) {
  .DriveTimeScatterPlot .scatter-plot-header {
    padding: 1rem 16px;
  }
  .DriveTimeScatterPlot .scatter-plot-header .header-left {
    gap: 8px;
  }
  .DriveTimeScatterPlot .scatter-plot-header .header-left .header-text .header-title {
    font-size: 15px;
  }
  .DriveTimeScatterPlot .scatter-plot-header .header-left .header-text .header-subtitle {
    font-size: 13px;
  }
  .DriveTimeScatterPlot .scatter-plot-content {
    padding: 16px;
  }
  .DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-placeholder {
    padding: 20px 16px;
    min-height: 300px;
  }
  .DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-placeholder .chart-icon-large i {
    font-size: 40px;
    width: 80px;
    height: 80px;
    padding: 20px;
  }
  .DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-placeholder .placeholder-title {
    font-size: 16px;
  }
  .DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-placeholder .placeholder-description {
    font-size: 13px;
  }
  .DriveTimeScatterPlot .scatter-plot-content .chart-section .chart-placeholder .requirements-section .requirements-list .requirement-item {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/features/DriveTimeTool/components/DriveTimeScatterPlot/styles.scss"],"names":[],"mappings":"AACE;EACE,yBAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;AAAJ;AAEI;EACE,UAAA;AAAN;AAIE;EACE,kBAAA;EACA,eAAA;EACA,sCAAA;AAFJ;AAII;EACE,yBAAA;AAFN;AAKI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAHN;AAMI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAJN;AAMM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAJR;AAMQ;EACE,eAAA;EACA,WAAA;AAJV;AASQ;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AAPV;AAUQ;EACE,eAAA;EACA,WAAA;EACA,SAAA;AARV;AAaI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAXN;AAaM;EACE,eAAA;EACA,WAAA;EACA,+BAAA;AAXR;AAgBE;EACE,6BAAA;EACA,aAAA;AAdJ;AAiBM;EACE,mBAAA;AAfR;AAiBQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAfV;AAiBU;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAfZ;AAiBY;EACE,eAAA;EACA,WAAA;AAfd;AAmBU;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;AAjBZ;AAoBU;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAlBZ;AAoBY;EACE,eAAA;EACA,cAAA;AAlBd;AAwBM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAtBR;AAwBQ;EACE,mBAAA;AAtBV;AAwBU;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAtBZ;AA0BQ;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AAxBV;AA2BQ;EACE,eAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAzBV;AA4BQ;EACE,gBAAA;EACA,gBAAA;AA1BV;AA4BU;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;AA1BZ;AA6BU;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AA3BZ;AA6BY;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,QAAA;AA3Bd;AA6Bc;EACE,gBAAA;AA3BhB;AA8Bc;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AA5BhB;AA8BgB;EACE,yBAAA;AA5BlB;AA+BgB;EACE,yBAAA;AA7BlB;AAgCgB;EACE,yBAAA;AA9BlB;AAwCE;EACE;IACE,kBAAA;EAtCJ;EAwCI;IACE,QAAA;EAtCN;EAyCQ;IACE,eAAA;EAvCV;EA0CQ;IACE,eAAA;EAxCV;EA8CE;IACE,aAAA;EA5CJ;EA+CM;IACE,kBAAA;IACA,iBAAA;EA7CR;EA+CQ;IACE,eAAA;IACA,WAAA;IACA,YAAA;IACA,aAAA;EA7CV;EAgDQ;IACE,eAAA;EA9CV;EAiDQ;IACE,eAAA;EA/CV;EAoDY;IACE,eAAA;EAlDd;AACF","sourcesContent":[".DriveTimeScatterPlot {\n  .scatter-plot-card {\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n\n    .card-body {\n      padding: 0;\n    }\n  }\n\n  .scatter-plot-header {\n    padding: 16px 2rem;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n\n    &:hover {\n      background-color: #f8f9fa;\n    }\n\n    .header-content {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n    }\n\n    .header-left {\n      display: flex;\n      align-items: center;\n      gap: 1rem;\n\n      .chart-icon {\n        width: 20px;\n        height: 20px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        i {\n          font-size: 16px;\n          color: #333;\n        }\n      }\n\n      .header-text {\n        .header-title {\n          font-size: 16px;\n          font-weight: 600;\n          color: #333;\n          margin: 0 0 2px 0;\n        }\n\n        .header-subtitle {\n          font-size: 14px;\n          color: #666;\n          margin: 0;\n        }\n      }\n    }\n\n    .collapse-icon {\n      width: 20px;\n      height: 20px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      i {\n        font-size: 14px;\n        color: #666;\n        transition: transform 0.2s ease;\n      }\n    }\n  }\n\n  .scatter-plot-content {\n    border-top: 1px solid #e0e0e0;\n    padding: 2rem;\n\n    .chart-section {\n      .chart-header {\n        margin-bottom: 2rem;\n\n        .chart-header-left {\n          display: flex;\n          align-items: center;\n          gap: 8px;\n\n          .chart-icon-small {\n            width: 18px;\n            height: 18px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n\n            i {\n              font-size: 14px;\n              color: #333;\n            }\n          }\n\n          .chart-title {\n            font-size: 16px;\n            font-weight: 600;\n            color: #333;\n            margin: 0;\n          }\n\n          .info-icon {\n            width: 16px;\n            height: 16px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n\n            i {\n              font-size: 1rem;\n              color: #6c757d;\n            }\n          }\n        }\n      }\n\n      .chart-placeholder {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        min-height: 350px;\n        background: #f8f9fa;\n        border-radius: 8px;\n        padding: 40px 20px;\n        text-align: center;\n\n        .chart-icon-large {\n          margin-bottom: 20px;\n\n          i {\n            font-size: 48px;\n            color: #6c757d;\n            background: #e9ecef;\n            padding: 2rem;\n            border-radius: 8px;\n            width: 96px;\n            height: 96px;\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n          }\n        }\n\n        .placeholder-title {\n          font-size: 18px;\n          font-weight: 600;\n          color: #333;\n          margin-bottom: 1rem;\n          max-width: 400px;\n        }\n\n        .placeholder-description {\n          font-size: 14px;\n          color: #666;\n          margin-bottom: 32px;\n          line-height: 1.5;\n          max-width: 400px;\n        }\n\n        .requirements-section {\n          text-align: left;\n          max-width: 350px;\n\n          .requirements-header {\n            font-size: 1rem;\n            font-weight: 600;\n            color: #666;\n            text-transform: uppercase;\n            letter-spacing: 0.5px;\n            margin-bottom: 16px;\n            text-align: center;\n          }\n\n          .requirements-list {\n            list-style: none;\n            padding: 0;\n            margin: 0;\n\n            .requirement-item {\n              display: flex;\n              align-items: flex-start;\n              font-size: 14px;\n              color: #333;\n              margin-bottom: 1rem;\n              gap: 8px;\n\n              &:last-child {\n                margin-bottom: 0;\n              }\n\n              .requirement-bullet {\n                width: 8px;\n                height: 8px;\n                border-radius: 50%;\n                margin-top: 6px;\n                flex-shrink: 0;\n\n                &.red {\n                  background-color: #dc3545;\n                }\n\n                &.green {\n                  background-color: #28a745;\n                }\n\n                &.blue {\n                  background-color: #007bff;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  @media (max-width: 768px) {\n    .scatter-plot-header {\n      padding: 1rem 16px;\n\n      .header-left {\n        gap: 8px;\n\n        .header-text {\n          .header-title {\n            font-size: 15px;\n          }\n\n          .header-subtitle {\n            font-size: 13px;\n          }\n        }\n      }\n    }\n\n    .scatter-plot-content {\n      padding: 16px;\n\n      .chart-section {\n        .chart-placeholder {\n          padding: 20px 16px;\n          min-height: 300px;\n\n          .chart-icon-large i {\n            font-size: 40px;\n            width: 80px;\n            height: 80px;\n            padding: 20px;\n          }\n\n          .placeholder-title {\n            font-size: 16px;\n          }\n\n          .placeholder-description {\n            font-size: 13px;\n          }\n\n          .requirements-section {\n            .requirements-list {\n              .requirement-item {\n                font-size: 13px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
